import { defineStore } from 'pinia';

import { router } from '@/router';
import { notify } from '@kyvg/vue3-notification';
import { http } from '@/http';
import { HttpStatusCode } from 'axios';
// import { useUserStore } from '@/stores';

// const baseUrl = `${import.meta.env.VITE_API_URL}/auth`;
const baseUrl = `/auth/v1`

function getItemChecked(item){
    const ls_item = localStorage.getItem(item) || null;
    try {
        const i = JSON.parse(ls_item);
        return i;
    } catch (err) {
        return null;
    }
}

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        user: getItemChecked('user'),
        returnUrl: null,
        token: getItemChecked('token')
    }),
    actions: {
        async sendSMS(userphone) {
            try {
                let resp = await http.post(`${baseUrl}/code`, {phone: userphone})
                console.log(resp)
                if (resp && resp.status == HttpStatusCode.Ok) {
                    let tm = resp.data.valid_until
                    console.log('sendSMS '+tm)
                    return [resp && resp.status == HttpStatusCode.Ok, tm]
                } else {
                    return null
                }
            } catch (error) {
                console.error(`on sendSMS ${error}`)
                throw new Error(error.response?.data?.reason || error.message)
            }
        },
        saveTokens(resp){
            console.log("auth.store saving new tokens")
            this.token = { 
                expires_at: resp.data.expires_at,
                access_token: resp.data.access_token,
                refresh_token: resp.data.refresh_token
            };
            localStorage.setItem('token', JSON.stringify(this.token))
        },
        clearTokens(){
            console.log("auth.store clearing tokens")
            localStorage.removeItem('token')
            this.token = null
        },
        async register(userphone, code) {
            try {
                let resp = await http.post(`${baseUrl}/token`, {phone: userphone, code: code});
                if  (resp.status == HttpStatusCode.Ok) 
                    this.saveTokens(resp);
                console.log(resp)
                const res = resp.status == HttpStatusCode.Ok && !(this.token === null) && !(this.token.access_token === null);
                console.log(`register result status ${resp.status == HttpStatusCode.Ok} token ${this.token.access_token} res=${res}`)
                if (res) {
                    const { useUserStore } = await import('@/stores/user.store.js');
                    await useUserStore().me();
                    if (this.returnUrl) {
                        setTimeout(()=>router.push(this.returnUrl,1000));
                        this.returnUrl = null;
                    } else {
                        setTimeout(()=>router.push('/objects'));
                    }
                }
                return res;
            } catch (error) {
                console.error(`on get token ${error}`)
                throw new Error(error.response?.data?.reason || error.message)
            }
        },
        logout() {
            console.log(`[LOGOUT] Before - user:`, this.user, `token:`, this.token);
            this.user = null;
            localStorage.removeItem('user');
            this.clearTokens();
            console.log(`[LOGOUT] After - user:`, this.user, `token:`, this.token);
            console.log(`[LOGOUT] isAuthentificated:`, this.isAuthentificated, `isAdmin:`, this.isAdmin);
        },
        setAuthHeader(config) {
            if (this.isAuthentificated)
                config.headers.Authorization = `Bearer ${this.token.access_token}`;
            else
                config.headers.Authorization = ``;
            return config
        },
    },
    getters: {
        isAuthentificated(state){
            const result = !(state.token === null) && !(state.token.access_token === null);
            console.log(`[GETTER] isAuthentificated called - token:`, state.token, `result:`, result);
            return result;
        },
        isAdmin(state){
            const result = (this.isAuthentificated && !(state.user === null) && (state.user.is_admin === true));
            console.log(`[GETTER] isAdmin called - user:`, state.user, `result:`, result);
            return result;
        }
    }
});
